import deburr from 'lodash-es/deburr';

function normalizeQuery(search: string): string {
    return deburr(search.toUpperCase());
}

export { normalizeQuery };



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/search-utils.ts